import { useAuthStore } from '@/store/auth'
import moment from 'moment'
export const generateNumdev = () => {
  const authStore = useAuthStore()

  const newDate = moment().format('YYYYMMDDHHmmssSS')
  return `${authStore.user?.id}${newDate}`
}
